export default {
  methods: {
    downloadFile(response, filename) {
      if (!filename) {
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
          if (fileNameMatch.length > 1) {
            filename = fileNameMatch[1];
          }
        }
      }

      let blob = new Blob([response.data], {
        type: response.headers['content-type']
      });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    }
  }
};
